import { Component, HostListener, Input } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
  animations: [
    trigger('visibilityChanged', [
      state('show', style({opacity: 1})),
      state('hide', style({opacity: 0})),
      transition('* => *', animate('.25s'))
    ])
  ]
})
export class ModalComponent {

  public isOpen = false;
  public hidden = true;

  public get animationState() {
    return this.isOpen ? 'show' : 'hide';
  }

  constructor() { }

  public open() {
    this.isOpen = true;
  }

  @HostListener('window:keydown.escape')
  public close() {
    this.isOpen = false;
  }

  public animationDone() {
    if (!this.isOpen) {
      this.hidden = true;
    }
  }

  public animationStart() {
    if (this.isOpen) {
      this.hidden = false;
    }
  }

  public clickCapture(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }


}

@Component({
  selector: 'app-modal-title',
  templateUrl: './modal-title.component.html'
})
export class ModalTitleComponent {

  @Input('title')title: string;
  @Input('ico')ico: string;

  constructor() { }

}

@Component({
  selector: 'app-modal-content',
  templateUrl: './modal-content.component.html'
})
export class ModalContentComponent {

  constructor() { }

}

@Component({
  selector: 'app-modal-footer',
  templateUrl: './modal-footer.component.html'
})
export class ModalFooterComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/modal/modal.component.ts